<template>
  <div class="card floating">
    <div class="card-content">
      <p v-if="emailCoupon === ''">{{ $t('prompts.deleteCoupon') }}</p>
      <p v-else>{{ $t('prompts.deleteCouponAsigned') }}</p>
    </div>
    <div class="card-action">
      <button @click="$store.commit('closeHovers')" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit"
        class="button button--flat button--red" id ="buttonDelete"
        :aria-label="$t('buttons.delete')"
        :title="$t('buttons.delete')">{{ $t('buttons.delete') }}</button>
    </div>
  </div>
</template>

<script>

import { mapMutations, mapState} from 'vuex';
import { files as ibbapi } from '@/api';
import buttons from '@/utils/buttons';

export default {
  name: 'delete-coupon',
  computed: {
    ...mapState(['idCoupon', 'emailCoupon'])
  },
  methods: {
    ...mapMutations(['closeHovers', 'setIdCoupon', 'setEmailCoupon']),
    submit: async function () {
      buttons.loading('delete');
      document.getElementById('buttonDelete').disabled = true;
      document.getElementById('buttonCancelDelete').disabled = true;
      try {
        if (this.idCoupon !== null) {
          await ibbapi.deleteCoupon(this.idCoupon);
          buttons.success('delete');
          this.closeHovers();
          this.$store.commit('setReload', true);
          return;
        } else {
          this.closeHovers();
        }
      } catch (e) {
        buttons.done('delete');
        this.closeHovers();
        this.$showError(e);
        this.$store.commit('setReload', true);
      }
    }
  },
  beforeDestroy () {
    this.setIdCoupon(null);
    this.setEmailCoupon('');
  }
};
</script>